import { render, staticRenderFns } from "./NotificationParticipantConsent.vue?vue&type=template&id=97c48f40&scoped=true&"
import script from "./NotificationParticipantConsent.vue?vue&type=script&lang=ts&"
export * from "./NotificationParticipantConsent.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationParticipantConsent.vue?vue&type=style&index=0&id=97c48f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c48f40",
  null
  
)

export default component.exports